import { PredefinedQuery } from './../predefined-queries.models';
import { Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { PredefinedQueriesService } from '../predefined-queries.service';
import { MatIconRegistry, MatSort, MatTableDataSource, Sort } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'oap-predefined-queries',
  templateUrl: './predefined-queries.component.html',
  styleUrls: ['./predefined-queries.component.scss']
})
export class PredefinedQueriesComponent implements OnInit {

  queries: PredefinedQuery[] = [];

  selectedRowIndex = -1;
  currentQuery: PredefinedQuery;

  displayedColumns: string[] = ['key', 'nom', 'description', 'withVariables', 'actions'];
  dataSource: MatTableDataSource<PredefinedQuery>;
  @ViewChild(MatSort) sort: MatSort;

  tooltip_execute = 'Exécuter';

  informations = '';

  constructor(private _router: Router,
    private _predefinedQueriesService: PredefinedQueriesService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer) {
      // tslint:disable-next-line:max-line-length
      iconRegistry.addSvgIcon('Execute', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-play_circle_filled_white-24px.svg'));
    }

  ngOnInit() {

    this.sort.sort({
      id: 'key',
      start: 'asc',
      disableClear: true
    });

    this.getQueries();
  }

  getQueries() {
    this._predefinedQueriesService.getQueries()
      .subscribe(
        response => {
          this.queries = response;
          this.dataSource = new MatTableDataSource(this.queries);
          this.sortData();
        },
        error => {
          console.error(error);
        }
      );
  }

  onSortData(sort: Sort) {
    this.sortData();
  }

  private sortData() {
    if (!this.dataSource) {
      return;
    }

    const data = this.dataSource.data;

    let sort: Sort = {
      active: this.sort.active,
      direction: this.sort.direction
    };

    if (!sort.active || sort.direction === '') {
      // tri par défaut
      sort = {
        active: '',
        direction: ''
      };
    }

    this.dataSource = new MatTableDataSource( data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'key': return compare(a.queryKey, b.queryKey, isAsc);
        case 'nom': return compare(a.queryName.toLocaleLowerCase(), b.queryName.toLocaleLowerCase(), isAsc);
        case 'description': return compare(a.queryDescription.toLocaleLowerCase(), b.queryDescription.toLocaleLowerCase(), isAsc);
        default: return compare(a.queryKey, b.queryKey, true);
      }
    }));
  }
}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

/** Builds and returns a new SearchResultData. */
function createPredefinedQuery(data: any): PredefinedQuery {
  return {
    queryKey: data.requeteKey,
    queryName: data.requeteNom,
    queryDescription: data.requeteDescription,
    variables: data.variables,
    withVariables: data.variables ? 'Oui' : 'Non',
    paginated: data.paginated
  };
}

